import React from "react";

const TextInput = ({
	title,
	onValueChange,
	currentValue,
	placeholder,
	isRequired,
	type = "text"
}) => {
	const inputRef = React.createRef();
	return (
		<div className="form-group">
			<label className="control-label">
				{title}
				{isRequired && <span className="required"> * </span>}
			</label>
			<input
				defaultValue={currentValue}
				onChange={e => onValueChange(e.target.value)}
				ref={inputRef}
				required={isRequired}
				type={type}
				placeholder={placeholder}
				name={title}
				className="form-control input-height"
			/>
		</div>
	);
};

export default TextInput;
